import React, { useState } from "react";
import images from "../../images";
import { useTranslation } from "react-i18next";

const QuestTypeSelect = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const questTypes = [
    { value: "INTRODUCE", label: t("quest.questType.introduce") },
    { value: "DEEP_DIVE", label: t("quest.questType.deepDive") },
    { value: "USER_JOURNEY", label: t("quest.questType.userJourney") },
    { value: "PULSE_CHECK", label: t("quest.questType.pulseCheck") },
    { value: "SNAP", label: t("quest.questType.snap") },
  ];

  const selectedType = questTypes.find((type) => type.value === value);

  const handleSelect = (typeValue) => {
    onChange(typeValue);
    setIsOpen(false);
  };

  return (
    <div className="bg-white rounded-xl p-4 w-full max-w-lg mt-4">
      {/* <label className="text-gray-400 text-sm">
        {t("quest.questType.label")} <span className="text-red-500">*</span>
      </label> */}

      <div className="relative mt-2">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`
            w-full p-3 bg-white border rounded-xl cursor-pointer flex items-center justify-between
            ${error ? "border-red-300" : "border-gray-300"}
            ${isOpen ? "border-indigo-500 ring-2 ring-indigo-200" : ""}
            hover:border-indigo-400 transition-colors
          `}
        >
          <span className={selectedType ? "text-gray-900" : "text-gray-400"}>
            {selectedType
              ? selectedType.label
              : t("quest.questType.placeholder")}
          </span>
          <img
            src={images.ChevronDownIcon}
            alt=""
            className={`w-4 h-4 transition-transform ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>

        {isOpen && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-xl shadow-lg max-h-60 overflow-y-auto">
            {questTypes.map((type) => (
              <div
                key={type.value}
                onClick={() => handleSelect(type.value)}
                className={`
                  px-4 py-3 cursor-pointer hover:bg-gray-50 transition-colors
                  ${
                    value === type.value
                      ? "bg-indigo-50 text-indigo-600"
                      : "text-gray-900"
                  }
                  first:rounded-t-xl last:rounded-b-xl
                `}
              >
                <div className="flex items-center justify-between">
                  <span className="text-sm">{type.label}</span>
                  {value === type.value && (
                    <div className="w-2 h-2 bg-indigo-600 rounded-full"></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default QuestTypeSelect;
